import { EntityIcon } from '@components/core-ui/EntityIcon/';
import { LeftSide } from './styles/LeftSide';
import { RightSide } from './styles/RightSide';
import { Wrapper } from './styles/Wrapper';
import { AdminUserDetailsResultDto } from 'app/API';

type TProps = {
  user: AdminUserDetailsResultDto;
};

export const Workspaces = ({ user }: TProps) => {
  if (!user) {
    return null;
  }

  const renderWorkspace = (workspace: AdminUserDetailsResultDto['workspaces'][0]) => {
    const org = (user.orgRelations ?? []).find((organization) => organization.id === workspace.organizationId);
    return (
      <div className="workspace" key={workspace.id}>
        <EntityIcon name={workspace.name || workspace.slug} className="workspace-shortName" />
        <div className="workspace-right">
          <div className="workspace-name">{workspace.name}</div>
          {!!org && <div className="workspace-org">{org.name}</div>}
        </div>
      </div>
    );
  };

  return (
    <Wrapper>
      <LeftSide>
        <h3>Workspace memberships</h3>
      </LeftSide>

      <RightSide>{(user.workspaces ?? []).map((workspace) => renderWorkspace(workspace))}</RightSide>
    </Wrapper>
  );
};
